import { reportSalesCustomerTypes } from './types';
import { newDate } from "helpers/dateTools";

const { SET_REPORT_SALES_CUSTOMER_FILTERS, RESTORE_INITIAL } = reportSalesCustomerTypes;

const initialState = {
  ReportSalesCustomer: [],
  startDate: newDate(),
  endDate: newDate(),
  station: [],
  customersOpt: [],
  searchCustomer: {},
  customer: {},
};

export const reportSalesCustomerReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case SET_REPORT_SALES_CUSTOMER_FILTERS:
      return {
        ...state,
        [payload.key]: payload.value
      }
    case RESTORE_INITIAL:
      return initialState

    default:
      return state;
  }
};